$(document).ready(function() {

    //add white background after scrolling

    $(window).scroll(function() {
        if ($(document).scrollTop() > 200) {
            $('nav').addClass('bg_white');
            if ($(window).width() < 992){
                $('.navbar-collapse').addClass('bg_white');
            }

        } else {
            $('nav').removeClass('bg_white');
            if ($(window).width() < 992) {
                $('.navbar-collapse').removeClass('bg_white');
            }
        }
    });

    //collapse menu after clicking a menu item

    $('.nav-item').on('click', function(){
        $('.navbar-collapse').removeClass('show');
    });
});